const productReplenishmentZone = () => {
	const zoneClassName = 'product-replenishment-zone';
	const closeButtonDesktopClassName =
		'product-replenishment-zone__close-button-desktop';
	const closeButtonMobileClassName =
		'product-replenishment-zone__close-button-mobile';

	const zone = document.querySelector(`.${zoneClassName}`);
	const closeButtonDesktop = document.querySelector(
		`.${closeButtonDesktopClassName}`,
	);
	const closeButtonMobile = document.querySelector(
		`.${closeButtonMobileClassName}`,
	);

	const toggleState = (element, state) => {
		element?.classList?.toggle(state);
	};

	closeButtonDesktop?.addEventListener('click', () => {
		toggleState(closeButtonDesktop, `${closeButtonDesktopClassName}--inactive`);
		toggleState(zone, `${zoneClassName}--inactive`);
	});

	closeButtonMobile?.addEventListener('click', () => {
		toggleState(zone, `${zoneClassName}--inactive`);
	});
};

export default productReplenishmentZone;
